import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios/requestInfo";

import { api } from "../../resources/api";

import { IClubImage, IHallGalleryItem } from "./types";

export const fetchGetClubImages = createAsyncThunk<IClubImage[]>(
  "images/fetchGetClubImages",
  async () => {
    try {
      const response = await axiosInstance.get(api.club.GALLERY_MAIN);
      
      let imagesArray: any[] = [];
      
      if (Array.isArray(response.data)) {
        const ourClub = response.data.find((item: any) => item.title === "Наш клуб");
        if (ourClub && Array.isArray(ourClub.img_urls)) {
          imagesArray = ourClub.img_urls;
        }
      } else if (response.data && Array.isArray(response.data.images)) {
        imagesArray = response.data.images;
      } else if (response.data && Array.isArray(response.data.img_urls)) {
        imagesArray = response.data.img_urls;
      }
      
      if (imagesArray.length > 0) {
        return imagesArray
          .filter((img: any) => !img.deleted_at)
          .sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
          .map((img: any) => ({
            id: img.id,
            url: img.url || img.img_url,
            order: img.order,
          }));
      }
      
      return [];
    } catch (error: any) {
      return [];
    }
  }
);

export const fetchGetHallsGallery = createAsyncThunk<IHallGalleryItem[]>(
  "images/fetchGetHallsGallery",
  async () => {
    try {
      const response = await axiosInstance.get(api.club.GALLERY);
      if (Array.isArray(response.data)) {
        return response.data
          .filter((item: any) => item.title !== "Наш клуб")
          .map((item: any, index: number) => ({
            id: item.id || index,
            title: item.title || "",
            images: Array.isArray(item.img_urls)
              ? item.img_urls
                  .filter((img: any) => !img.deleted_at)
                  .sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
                  .map((img: any) => ({
                    id: img.id,
                    url: img.url,
                    order: img.order,
                  }))
              : [],
          }))
          .filter((item: IHallGalleryItem) => item.images.length > 0);
      }
      return [];
    } catch (error: any) {
      return [];
    }
  }
);
